// This file is used for build without proxy
// It's the same as environment.ts but with useProxy: false
export const environment = {
  production: false,
  // apiCatalogos: 'http://10.57.164.134:908/candidato-api-2',
  // apiCandidatos: 'http://10.57.164.134:908/ms-candidatos',
  // apiMetaDefender: 'https://api.metadefender.com',

  // apiKeyMetaDefender: 'b82ef4293bb846f4ace7443a1e37b25d'
  urlStorage: 'http://201.161.107.6:21/Files/dev.jobboard/candidato/cv/',
  urlApi: 'http://10.57.164.134:9080',
  urlApiCandidato: 'https://manpowermexico-dev.appiancloud.com/api-candidato',
  urlApiVacantes: 'https://manpowermexico-dev.appiancloud.com/api-vacantes',
  urlResetPasswordValidator: 'https://sandbox-empleos.manpowergroup.com.mx/cambio-credenciales/',
  // urlResetPasswordValidator: 'http://localhost/cambio-credenciales',

  apiCatalogos: 'https://appapi.manpower.com.mx/candidatos/candidato-api-2',
  apiCandidatos: 'https://appapi.manpower.com.mx/ms-candidatos/ms-candidatos',
  apiVacantes:'https://appapi.manpower.com.mx/candidatos',
  apiMetaDefender: 'https://api.metadefender.com',

  apiKeyMetaDefender: 'b82ef4293bb846f4ace7443a1e37b25d',
  
  urlAppian: '/api/appian',
  useProxy: false, // No usar proxy en builds (solo funciona con ng serve)
  appianApiKey: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiIyOGE1MDg3ZC02ODgwLWZmNzgtODNlNy02Y2VmMzg2ZTJkMmUifQ.EqtMZkX93MpJQDqWgS1kxw2jcuu-AqHH7cwBQrt2etU',
  
  // Servicios Appian específicos
  urlAppianMakeCandidate: 'https://manpowermexico-dev.appiancloud.com/suite/webapi/make_candidate',
  urlAppianGetCandidate: 'https://manpowermexico-dev.appiancloud.com/suite/webapi/get-candidate',
  urlAppianObtenerResume: 'https://manpowermexico-dev.appiancloud.com/suite/webapi/obtener-resume',
  urlAppianUploadCvPortal: 'https://manpowermexico-dev.appiancloud.com/api/appian/upload_cv_portal',
  urlAppianPosiciones: 'https://manpowermexico-dev.appiancloud.com/suite/webapi/posiciones'
};

